import styles from './styles.m.scss';

const Border = () => {
  return <div className={styles.border} />;
};

export default Border;
